export const NOTIFICATION_API_TEMPLATE = {
    INIT: 'api/notification/fire-base/init',
}